import {GAMES_SCV_STATS, PLAYERS_SCV_STATS} from "../../../services/api/api.urls";
import {StatsType} from "../Statistics";

export const defineUrlByStatsType = (type: StatsType) => {
    return type === StatsType.PLAYERS ? PLAYERS_SCV_STATS : GAMES_SCV_STATS
}
